import { render, staticRenderFns } from "./MenuApp.vue?vue&type=template&id=6b548868&scoped=true&"
import script from "./MenuApp.ts?vue&type=script&lang=ts&"
export * from "./MenuApp.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b548868",
  null
  
)

export default component.exports
import {QItem,QItemSection,QIcon,QSeparator,QItemLabel,Ripple} from 'quasar'
component.options.components = Object.assign({QItem,QItemSection,QIcon,QSeparator,QItemLabel}, component.options.components || {})
component.options.directives = Object.assign({Ripple}, component.options.directives || {})
